import { cn } from '@dc-shared-web/lib'

const Spinner = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'tw-animate-spin tw-inline-block tw-w-6 tw-h-6 tw-border-[3px] tw-border-current tw-border-t-transparent tw-text-primary tw-rounded-full',
        className
      )}
      role='status'
      aria-label='loading'
    >
      <span className='tw-sr-only'>Loading...</span>
    </div>
  )
}

export default Spinner
